import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/formatting';

const badgeVariants = cva('inline-flex items-center gap-1 font-medium', {
  variants: {
    variant: {
      default: 'bg-red-primary/10 text-red-primary border border-red-primary/30',
      accent: 'bg-red-primary text-white font-semibold shadow',
      success: 'bg-green-500/20 text-green-400',
      warning: 'bg-amber-500/20 text-amber-500',
      overlay: 'bg-black/80 text-white font-medium',
      outline: 'bg-white/10 text-white/40 border border-white/20',
      //solid
      outlineSolid: 'bg-white/40 text-white border border-white/20',
    },
    size: {
      sm: 'px-1.5 py-0.5 text-xs rounded',
      md: 'px-2 py-1 text-xs rounded-full',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
});

type BadgeProps = React.ComponentProps<'span'> & VariantProps<typeof badgeVariants>;

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <span
      data-slot="badge"
      className={cn(badgeVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Badge, badgeVariants, type BadgeProps };
